export default "__VITE_ASSET__tmfOnUmw__"